import React from 'react';
import clipper from 'text-clipper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

type Props = {
  label: string;
  text: string | undefined;
  isHtml: boolean;
  maxTextLength?: number;
};

const getTextAccordingToLength = (
  text: string,
  maxTextLength: number,
  isFullTextShown: boolean,
  isHtml: boolean,
): string => {
  if (!isFullTextShown && text.length > maxTextLength) {
    return clipper(text, maxTextLength, { html: isHtml, maxLines: 2 });
  }
  return text;
};

function TextExpander({ label, text, isHtml, maxTextLength = 125 }: Props) {
  const [isFullTextShown, setIsFullTextShown] = React.useState<boolean>(false);

  return (
    <Stack className='text-expander' direction='column' spacing={1} justifyContent='center'>
      <Typography fontWeight='bold'>{label}</Typography>
      {text !== undefined && text.length >= 0 && (
        <Typography
          style={{
            whiteSpace: 'pre-line',
            wordBreak: 'break-word',
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            marginTop: '0',
          }}
          fontSize='0.8rem'
        >
          <span
            style={{ display: 'inline' }}
            dangerouslySetInnerHTML={{ __html: getTextAccordingToLength(text, maxTextLength, isFullTextShown, isHtml) }}
          />
          {text.length > 125 && (
            <IconButton
              size='small'
              style={{
                marginLeft: '1rem',
                marginRight: '1rem',
              }}
              onClick={() => {
                setIsFullTextShown(!isFullTextShown);
              }}
            >
              {isFullTextShown ? (
                <KeyboardDoubleArrowLeftIcon fontSize='inherit' />
              ) : (
                <KeyboardDoubleArrowRightIcon fontSize='inherit' />
              )}
            </IconButton>
          )}
        </Typography>
      )}
    </Stack>
  );
}

export default TextExpander;
